import React from "react";
import PropTypes from "prop-types";

/**
 * This component a color swatch element
 *
 * @author Afifa Saleem <afifa@250mils.com>
 */
const ColorSwatch = ({color, className, onClick, onDoubleClick}) => {

    return (
        <div className={'color-swatch ' + className}
             style={{background: `#${color}`}}
             onClick={() => onClick(color)}
             onDoubleClick={onDoubleClick}
        />
    );
}

ColorSwatch.prototypes = {
    /**
     * the hex string for color to be displayed in swatch
     */
    color: PropTypes.string.isRequired,
    /**
     * optional class for color swatch
     */
    className: PropTypes.string,
    /**
     * the click handler for when color swatch is clicked
     */
    onClick: PropTypes.func.isRequired,
    /**
     * the click handler for when color swatch is double-clicked
     */
    onDoubleClick: PropTypes.func
}

export default ColorSwatch;